import React from "react";
import { useNavigate } from "react-router-dom";

export default function PricingSection({ data }) {
  const navigate = useNavigate();
  return (
    <div className="py-5">
      <div className="custom-container text-center">
        {/* HEADER */}
        <h2 className="main-title FS40FW600">
          {data.title}{" "}
          <span className="text-success FS40FW600">{data.highlight}</span>{" "}
          {data.subtitle}
        </h2>

        <p className="quote-para FS18FW400 fw-500">{data.note}</p>

        {/* CARDS */}
        <div className="row mt-5 g-4 justify-content-center">
          {data.plans.map((plan, i) => (
            <div className="col-lg-4 col-md-6" key={i}>
              <div
                className={`price-card plus-sans ${plan.highlightCard ? "highlight-card" : ""}`}
              >
                {/* BADGE */}
                {plan.badge && <div className="pricing-badge FS16FW500 fw-400">{plan.badge}</div>}

                {/* SIMPLE PLAN */}
                {!plan.highlightCard && (
                  <>
                    <p className="FS16FW500">{plan.name}</p>
                    <h3 className="FS40FW600">{plan.price} {plan.priceByText && <span className="plus-sans FS14FW600 subtitle">{plan.priceByText}</span>}</h3>
{/* ${f.active ? "active" : "inactive"} */}
                    <ul className="feature-list-price">
                      {plan.features.map((f, i) => (
                        <li
                          key={i}
                          className={`FS17FW500`}
                          style={{color:'#141414'}}
                        >
                          {f.active ? (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.99935 18.3337C14.5827 18.3337 18.3327 14.5837 18.3327 10.0003C18.3327 5.41699 14.5827 1.66699 9.99935 1.66699C5.41602 1.66699 1.66602 5.41699 1.66602 10.0003C1.66602 14.5837 5.41602 18.3337 9.99935 18.3337Z"
                                stroke="#34C759"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M6.45898 9.99993L8.81732 12.3583L13.5423 7.6416"
                                stroke="#34C759"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.99935 18.3337C14.5827 18.3337 18.3327 14.5837 18.3327 10.0003C18.3327 5.41699 14.5827 1.66699 9.99935 1.66699C5.41602 1.66699 1.66602 5.41699 1.66602 10.0003C1.66602 14.5837 5.41602 18.3337 9.99935 18.3337Z"
                                stroke="#999999"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.64258 12.3583L12.3592 7.6416"
                                stroke="#999999"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.3592 12.3583L7.64258 7.6416"
                                stroke="#999999"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}{" "}
                          {f.text}
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {/* PREMIUM PLAN */}
                {plan.highlightCard && (
                  <>
                    <p className="FS24FW500 fw-600">{plan.name}</p>
                    <p className="FS14FW600">{plan.description}</p>

                    <ul className="feature-list-price">
                      {plan.features.map((f, i) => (
                        <li key={i} className="FS17FW500">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.0013 18.3337C14.5846 18.3337 18.3346 14.5837 18.3346 10.0003C18.3346 5.41699 14.5846 1.66699 10.0013 1.66699C5.41797 1.66699 1.66797 5.41699 1.66797 10.0003C1.66797 14.5837 5.41797 18.3337 10.0013 18.3337Z"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M6.45703 9.99993L8.81536 12.3583L13.5404 7.6416"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}

                          <strong className="FS16FW500 fw-700">
                            {f.title}
                          </strong>
                          <p className="FS14FW600 px-4" style={{ color: "#D0D0D0" }}>
                            {f.desc}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                <button
                    className={`card-btn plus-sans FS17FW500 w-100 ${
                      plan.highlightCard ? "primary-btn" : "cta-btn"
                    }`}
                    onClick={() => {
                      const link = plan.buttonLink || '/auth/register';
                      if (link.startsWith('http')) window.location.href = link;
                      else navigate(link);
                    }}
                  >
                    {plan.button}{" "}
                    <img
                      src={`/images/web-new-images/${plan.highlightCard ? "right-arrow.svg" : "right-arrow-black.svg"}`}
                      alt="Register Now"
                    />
                  </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
